module.exports = {"130404001":"胜利桥街道","130404002":"百家村街道","130404003":"铁路大院街道","130404004":"化林路街道","130404005":"庞村街道","130404006":"二六七二街道","130404007":"石化街道","130404100":"户村镇","130404200":"彭家寨乡","130404201":"康庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130404.json
// module id = 101
// module chunks = 0